import {
  SET_BUSINESS_FILTERS,
  SET_BUSINESS_GRID_SORT_CRITERIA,
  RESET_BUSINESS_FILTERS,
} from './actionTypes';

export const setBusinessFilters = filters => ({
  type: SET_BUSINESS_FILTERS,
  filters,
});

export const cleanBusinessFilters = () => ({
  type: RESET_BUSINESS_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_BUSINESS_GRID_SORT_CRITERIA,
  sortCriteria,
});
